module.exports = __webpack_public_path__ + "img/视频封面23.0734cd25.png";